<template>
  <div class="exception-body error">
    <div class="exception-content">
      <div class="exception-title">{{ $t('error_title') }}</div>
      <div class="exception-detail">{{$t('error_label')}}</div>
      <router-link to="/">{{$t('error_linkDashboard')}}</router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>
